// Driver certification / competency types (split from storage-types.ts).
// LOW-LEVEL: referenced by driver-employment and compliance modules. No imports.

import type { DataSourceMeta } from './core-types';

export interface CertificationEntry {
  number?: string;
  issuedDate?: string;
  expiryDate?: string;
  issuedBy?: string;
  // Data source and verification (v4.2 P15)
  sourceType?: DataSourceMeta['sourceType'];
  verificationStatus?: DataSourceMeta['verificationStatus'];
  verifiedBy?: string;
  verifiedAt?: string;
  documentRef?: string;  // Reference to DocumentManager file
}

export interface DriverCertifications {
  taxiPermit?: CertificationEntry;          // Køyreseddel
  driverLicense?: CertificationEntry;       // Førarkort
  firstAid?: CertificationEntry;            // Førstehjelp
  professionalCompetence?: CertificationEntry; // Yrkessjåførkompetanse
  hmsTraining?: CertificationEntry;         // HMS-opplæring
  customCertificates?: Array<{
    key: string;
    label: string;
    entry: CertificationEntry;
  }>;
}

export type DriverComplianceStatus =
  | 'unknown'         // No certifications registered (initial/migrated state)
  | 'compliant'       // All mandatory requirements met, none expiring soon
  | 'expiring_soon'   // One+ mandatory requirements expiring within warning period
  | 'non_compliant';  // One+ mandatory requirements expired or missing

export interface CompetencyRequirement {
  certificationKey: keyof DriverCertifications;
  requiredFor: 'all_drivers' | 'loyve_holders' | 'employed_drivers';
  isMandatory: boolean;
  warningDaysBeforeExpiry: number;
}

export const DEFAULT_COMPETENCY_REQUIREMENTS: CompetencyRequirement[] = [
  { certificationKey: 'taxiPermit', requiredFor: 'all_drivers', isMandatory: true, warningDaysBeforeExpiry: 60 },
  { certificationKey: 'driverLicense', requiredFor: 'all_drivers', isMandatory: true, warningDaysBeforeExpiry: 90 },
  { certificationKey: 'firstAid', requiredFor: 'all_drivers', isMandatory: true, warningDaysBeforeExpiry: 60 },
  { certificationKey: 'professionalCompetence', requiredFor: 'loyve_holders', isMandatory: true, warningDaysBeforeExpiry: 0 },
  { certificationKey: 'hmsTraining', requiredFor: 'employed_drivers', isMandatory: false, warningDaysBeforeExpiry: 60 },
];
